<template>
  <div class="view home">
    <router-view></router-view>
  </div>
</template>

<script>

import PortalSettings from '@/models/PortalSettings';

function maybeRedirect(to, from, next) {
  if (to.name === 'home') {
    // TODO jamie maybe we need to redirect to some other hardcoded page based on PortalSettings
    next({ replace: true, name: 'category-activity', params: to.params })
  } else {
    next();
  }
}

export default {
  beforeRouteEnter(to, from, next) {
    maybeRedirect(to, from, next);
  },

  beforeRouteUpdate(to, from, next) {
    maybeRedirect(to, from, next);
  },

  computed: {
    enableGiftCert() {
      return PortalSettings.get('enableGiftCert', false);
    }
  }
}
</script>

<style lang="scss">
.view.home {
  margin-top: 10px;
  @include breakpoint(medium) {
    margin-top: 0;
  }

  nav {
    display: flex;
    margin-bottom: 15px;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 16px;
      text-align: center;
      height: 40px;
      width: 25%;
      min-width: 72px;
      max-width: 120px;
      @include breakpoint(medium) {
        font-size: 15px;
        height: 44px;
      }

      &.router-link-active {
        color: $colorDefault;
        background-color: $colorPaleBlueGray;
        cursor: default;
      }
    }
  }
}
</style>